import React from "react";
import "./PrivacyPolicy.css";
import PublicHeader from "../../components/public/PublicHeader";
import PublicFooter from "../../components/public/PublicFooter";

const PrivacyPolicy = () => {
    return (
        <div className="privacy-page">
            <PublicHeader />
            <section className="public-hero">
                <div className="privacy-container">
                    <h1 className="privacy-title">Zinea Privacy Policy</h1>
                    <p><strong>Effective Date:</strong> August 9, 2024</p>
                </div>
            </section>
            <div className="privacy-container">
                <div className="privacy-content">

                    <p>Welcome to Zinea! Your privacy is important to us. This Privacy Policy outlines how Zinea ("we," "our," or
                        "us") collects, uses, discloses, and protects your personal information when you use our mobile application
                        ("App").</p>

                    <h2>1. Information We Collect</h2>
                    <p><strong>1.1 Personal Information:</strong> We may collect personal information such as your name, email, phone number, and profile details.</p>
                    <p><strong>1.2 Usage Data:</strong> Information about your interactions with the App.</p>
                    <p><strong>1.3 Device Information:</strong> Details like device type, OS, and unique identifiers.</p>
                    <p><strong>1.4 Location Data:</strong> With your permission, we may collect location data.</p>

                    <h2>2. How We Use Your Information</h2>
                    <p><strong>2.1 Provide and Improve Services:</strong> Used to personalize and improve App functionality.</p>
                    <p><strong>2.2 Communication:</strong> Updates, promotional offers, and App-related notifications.</p>
                    <p><strong>2.3 Analytics:</strong> Monitor trends, usage, and improve services.</p>
                    <p><strong>2.4 Compliance and Protection:</strong> Legal compliance, security, and fraud prevention.</p>

                    <h2>3. Sharing Your Information</h2>
                    <p><strong>3.1 Third-Party Service Providers:</strong> We may share data with hosting, analytics, and support providers.</p>
                    <p><strong>3.2 Legal Requirements:</strong> If required by law or in response to valid government requests.</p>
                    <p><strong>3.3 Business Transfers:</strong> In case of mergers or acquisitions.</p>

                    <h2>4. Security of Your Information</h2>
                    <p>We implement security measures, but no system is completely secure.</p>

                    <h2>5. Your Choices</h2>
                    <p><strong>5.1 Account Information:</strong> Update via profile settings.</p>
                    <p><strong>5.2 Location Data:</strong> Can be disabled in device settings.</p>
                    <p><strong>5.3 Communication Preferences:</strong> Opt-out of promotional messages.</p>

                    <h2>6. Children's Privacy</h2>
                    <p>Not intended for users under 13. If found, we delete such data.</p>

                    <h2>7. Changes to This Privacy Policy</h2>
                    <p>We may update this policy. Continued use means acceptance.</p>

                    <h2>8. Contact Us</h2>
                    <p><strong>Email:</strong> <a href="mailto:connect@zinea.app">connect@zinea.app</a></p>
                    <p><strong>Address:</strong> Zinea Lifestyles, Sector 58, Gurgaon, India</p>
                </div>
            </div>
            <PublicFooter />
        </div>
    );
};

export default PrivacyPolicy;
